(function () {
  angular.module("akitabox.ui.dialogs.assetCondition", [
    "ngMaterial",
    "akitabox.core.constants",
    "akitabox.core.services.asset",
    "akitabox.core.services.condition",
    "akitabox.core.toast",
  ]);
})();
